var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RestartIcon } from '../../../svg/RestartIcon';
import { MetricController } from '../../MetricForm/Controller/MetricController';
import { restartConversation, isDev, isMobile, getURLParamValue, } from '../../../clearstep/util/AppHelpers';
import { THEME } from '../../../clearstep/util/Theme';
import '../../../clearstep/proto/conversation_pb';
export var ConversationControls = function (props) {
    var conversationInProgress = props.conversationInProgress, isClearstepEmployee = props.isClearstepEmployee, conversationId = props.conversationId, partner = props.partner, conversationType = props.conversationType;
    var _a = useState(''), copySuccess = _a[0], setCopySuccess = _a[1];
    var _b = useState(false), copiedNLPLabels = _b[0], setCopiedNLPLabels = _b[1];
    var t = useTranslation().t;
    var handleRestart = function () {
        restartConversation(conversationType);
    };
    var handleCopyUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
        var url, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "/partner/".concat(partner, "/?conversation_id=").concat(conversationId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(window.location.origin + url)];
                case 2:
                    _a.sent();
                    setCopySuccess('Copied!');
                    setTimeout(function () { return setCopySuccess(''); }, 2000);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setCopySuccess('Failed to copy');
                    setTimeout(function () { return setCopySuccess(''); }, 2000);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCopyNLPLabels = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, fetch("/conversations/".concat(conversationId, "/nlp"))];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (!(Array.isArray(data.labels) && data.labels.length > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, navigator.clipboard.writeText(data.labels.join(', '))];
                case 3:
                    _a.sent();
                    setCopiedNLPLabels(true);
                    setTimeout(function () {
                        setCopiedNLPLabels(false);
                    }, 2000);
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    console.error('Error fetching NLP labels:', e_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Get partner theme styles
    var buttonStyle = {
        backgroundColor: THEME.primaryColor || '#0070f3',
        color: 'white',
        borderColor: THEME.primaryColor || '#0070f3',
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "box-border hidden display-mobile-feedback:absolute display-mobile-feedback:bottom-14 display-mobile-feedback:flex display-mobile-feedback:w-full display-mobile-feedback:flex-row-reverse display-mobile-feedback:items-center display-mobile-feedback:justify-between display-mobile-feedback:px-6 display-mobile-feedback:py-0" }, conversationInProgress && (React.createElement("button", { className: "flex flex-row items-center rounded-full border border-solid border-common-bot-medium-gray bg-white px-4 py-2 shadow-conversation-message focus-within:shadow-focus-outset", onClick: handleRestart },
            React.createElement(RestartIcon, { className: "h-4 w-4 pr-2" }),
            React.createElement("p", { className: "text-sm font-semibold text-common-charcoal" }, t('common.restart', 'Restart'))))),
        React.createElement("div", { className: "sticky bottom-0 right-0 z-10" },
            React.createElement("div", { className: "absolute bottom-0 right-0 flex flex-col items-end pr-5 display-mobile-feedback:w-full display-mobile-feedback:pr-0" },
                conversationInProgress && (React.createElement("button", { className: "mb-4 flex flex-row items-center rounded-full border border-solid border-common-bot-medium-gray bg-white px-6 py-3 shadow-conversation-message focus-within:shadow-focus-outset display-mobile-feedback:hidden", onClick: handleRestart },
                    React.createElement(RestartIcon, { className: "pr-2" }),
                    React.createElement("p", { className: "font-semibold text-common-charcoal" },
                        ' ',
                        t('common.restart', 'Restart')))),
                (isClearstepEmployee || isDev() || getURLParamValue('utm_source') === 'call-center') &&
                    !isMobile() && (React.createElement("div", { className: "relative mb-4" },
                    React.createElement("button", { className: "flex flex-row items-center rounded-full border border-solid px-6 py-3 shadow-conversation-message transition-opacity focus-within:shadow-focus-outset hover:opacity-90", onClick: handleCopyUrl, style: buttonStyle },
                        React.createElement("p", { className: "font-semibold" }, copySuccess || 'Copy URL')))),
                (isClearstepEmployee || isDev()) && !isMobile() && (React.createElement("div", { className: "relative mb-4" },
                    React.createElement("button", { className: "flex flex-row items-center rounded-full border border-solid px-6 py-3 shadow-conversation-message transition-opacity focus-within:shadow-focus-outset hover:opacity-90", onClick: handleCopyNLPLabels, style: buttonStyle },
                        React.createElement("p", { className: "font-semibold" }, copiedNLPLabels || 'Copy NLP Labels')))),
                React.createElement("div", { className: "display-mobile-feedback:mr-5 mobile:mr-0 mobile:w-full" },
                    React.createElement(MetricController, null))))));
};
